<template>
  <b-card class="analysis-header-card">
    <div class="header-top">
      <button
        type="button"
        class="back-button"
        @click="$emit('back')"
      >
        <feather-icon
          icon="ArrowLeftIcon"
          size="24"
        />
      </button>

      <div class="header-title">
        <span class="page-title">
          Pré-Análise
        </span>

        <div
          class="analysis-status"
          :class="statusClass"
        >
        <span class="status-icon">
          <feather-icon
            :icon="statusIcon"
            size="18"
          />
        </span>

        <span>{{ analysis.status }}</span>
      </div>
    </div>
  </div>
    <div class="header-divider" />
<div class="company-info">
  <div class="info-item">
    <strong>Cliente: </strong>
    <span>{{ company.name }}</span>
  </div>

  <div class="info-item">
    <strong>CNPJ: </strong>
    <span>{{ company.document | tax_id }}</span>
  </div>

  <div class="info-item">
    <strong>Data da Análise: </strong>
    <span>{{ analysis.analysisDate | date }}</span>
  </div>

  <div class="info-item">
    <strong>Proposta: </strong>
    <span>{{ analysis.proposal }}</span>
      </div>
    </div>
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'

export default {
  name: 'PreAnalysisHeader',

  components: {
    BCard
  },

  props: {
    company: {
      type: Object,
      required: true
    },

    analysis: {
      type: Object,
      required: true
    }
  },

 computed: {
  statusIcon() {
    const status = this.analysis.status.toLowerCase()

    if (status.includes('aprovada')) {
      return 'CheckIcon'
    }

    if (status.includes('pendente')) {
      return 'ClockIcon'
    }

    return 'XIcon'
  },

  statusClass() {
    const status = this.analysis.status.toLowerCase()

    if (status.includes('aprovada')) {
      return 'status-approved'
    }

    if (status.includes('pendente')) {
      return 'status-pending'
    }

    return 'status-rejected'
  }
}
}
</script>

<style scoped>
.analysis-header-card {
  border: 0;
  border-radius: 8px;
  margin-bottom: 16px;
}

.header-top {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  margin-bottom: 20px;
}

.back-button {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0;
  border: 0;
  color: var(--secondary);
  background: transparent;
  cursor: pointer;
}

.header-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.page-title {
  display: flex;
  align-items: center;
  min-height: 40px;
  color: var(--secondary);
  font-size: 24px;
  font-weight: 700;
}

.analysis-status {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 40px;
  padding: 5px 14px;
  border-radius: 20px;
  font-size: 24px;
  font-weight: 700;
}

.status-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
}

.status-approved {
  color: #28a745;
}

.status-approved .status-icon {
  background: #e8f7ed;
}

.status-pending {
  color: #d98b00;
}

.status-pending .status-icon {
  background: #fff4d9;
}

.status-rejected {
  color: #dc3545;
}

.status-rejected .status-icon {
  background: #fdebed;
}

.header-spacer {
  width: 100%;
}

.company-info {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  line-height: 1.7;
}

.company-info strong {
  font-weight: 700;
}

.analysis-info {
  text-align: left;
}
.header-divider {
  width: 100%;
  height: 1px;
  margin: 16px 0;

  background: rgba(255, 255, 255, 0.06);
}
.company-info {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  line-height: 1.7;
}

.company-info strong {
  font-weight: 700;
}

.analysis-info {
  text-align: left;
}

@media (max-width: 768px) {
  .header-top {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .analysis-status {
    justify-content: flex-start;
    font-size: 19px;
  }

  .header-spacer {
    display: none;
  }

  .company-info {
    flex-direction: column;
    gap: 12px;
  }
}
</style>